module.exports = __webpack_public_path__ + "img/list_bg2.0e7e3820.png";